import { defineComponent as _defineComponent } from 'vue'
import { groupBy } from 'lodash'
import { computed } from 'vue'
import PositionedInventory from '@/models/inventory'
import LocationRow from '@/components/jobs/LocationRow.vue'
import VsText from '@/components/vision/VsText.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'JobCardLocationsDetail',
  props: {
    destinationLocationName: null,
    inventory: null,
    highlightDestination: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
  destinationLocationName: string
  inventory: PositionedInventory[]
  highlightDestination?: boolean
}



const groupedInventory = computed(() => groupBy(props.inventory, 'position'))
const formatInventories = (invGroup) => {
  return invGroup.map(
    (inv: PositionedInventory) =>
      `(Qty ${inv.quantity}) ${inv.inventorySubTypeName} · ${inv.name}`
  )
}

return { __sfc: true,props, groupedInventory, formatInventories, LocationRow, VsText }
}

})